import React from 'react';
import PropTypes from 'prop-types';
import TextInput from "./";

const _MobileTextInput = (props) => {

    const format = (str) => {
        const parts = [];
        // strip to just numerical
        const parsed = str.replace(/\D/g, '');

        parts.push(parsed.substring(0, 4));

        if (parsed.length > 4) {
            parts.push(parsed.substring(4, 7));
        }

        if (parsed.length > 7) {
            parts.push(parsed.substring(7));
        }

        return parts.join(' ');
    };

    const removeFormat = (str) => str.replace(/\D/g, '');

    const { value, onChange, ...otherProps } = props;

    const newValue = format(value);

    const handleChange = (event) => {
        const val = removeFormat(event.target.value.trim());
        props.onChange({
            target: {
                value: val,
                name: props.name,
                type: 'text',
            }
        });
    }

    return (
        <TextInput
            {...otherProps}     
            onChange={handleChange}
            value={newValue}
        />
    );
}

export default class MobileTextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clean: this.clean(props.value),
            formatted: this.format(props.value.trim()),
        };
        this.handleChange = this.handleChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.MAX_LENGTH = 10;
    }

    format(str) {
        const parts = [];
        // strip to just numerical
        const parsed = this.removeFormat(str.trim());

        parts.push(parsed.substring(0, 4));

        if (parsed.length > 4) {
            parts.push(parsed.substring(4, 7));
        }

        if (parsed.length > 7) {
            parts.push(parsed.substring(7));
        }

        return parts.join(' ');  
    }

    removeFormat(str) {
        return str.replace(/\D/g, '');
    }

    clean(str) {
        return this.removeFormat(str.trim());
    }

    onBlur() {
        this.setState({
            editing: false,
            clean: this.format(this.state.clean),
        });
    }

    onFocus() {
        this.setState({
            editing: true,
        });
    }

    handleChange(e) {
        const val = e.target.value;
        this.setState({
            clean: val,
            formatted: this.format(val),
        }, () => {
            this.props.onChange({
                target: {
                    value: this.clean(val),
                    name: this.props.name,
                    type: 'text',
                }
            });
        });
    }

    render() {
        const { onChange, ...otherProps } = this.props;
        return (
            <TextInput
                {...otherProps}     
                onChange={this.handleChange}
                value={this.state.editing ? this.state.clean : this.state.formatted}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
            />
        );
    }
}

MobileTextInput.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    warning: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

// export default MobileTextInput;
